export const REFUND_POLICY = {
  DAY_BEFORE: 2,
  FIFTEEN_DAYS: 3,
  FIVE_DAYS: 6,
  FOURTEEN_DAYS: 9,
  NEVER: 1,
  SEVEN_DAYS: 5,
  SIX_DAYS: 7,
  TEN_DAYS: 8,
  TWO_DAYS: 4,
}
export const REFUND_POLICY_DAYS_MAP = {
  [REFUND_POLICY.TWO_DAYS]: 2,
  [REFUND_POLICY.FIVE_DAYS]: 5,
  [REFUND_POLICY.SIX_DAYS]: 6,
  [REFUND_POLICY.SEVEN_DAYS]: 7,
  [REFUND_POLICY.TEN_DAYS]: 10,
  [REFUND_POLICY.FOURTEEN_DAYS]: 14,
  [REFUND_POLICY.FIFTEEN_DAYS]: 15,
  [REFUND_POLICY.DAY_BEFORE]: 1,
  [REFUND_POLICY.NEVER]: 0,
}
